var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarWhitebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2793 0.821442C35.5233 0.821442 41.9714 5.38738 44.3415 12.1952C46.7115 19.0031 44.4827 26.5567 38.7895 31.0114C48.5278 34.855 54.8974 40.2063 56.0549 50.5622C56.2207 52.1008 55.1077 53.4845 53.5619 53.6613H53.2503C51.7998 53.6701 50.5769 52.5877 50.4174 51.1538C49.1294 39.7511 39.8737 34.6544 28.3359 34.6544C16.7982 34.6544 7.54246 39.7511 6.25451 51.1538C6.08241 52.7099 4.67454 53.8325 3.10994 53.6613C1.54535 53.4902 0.416519 52.09 0.588624 50.534C1.74055 40.2085 8.07217 34.875 17.7691 31.0114C12.0758 26.5567 9.84703 19.0031 12.2171 12.1952C14.5872 5.38738 21.0352 0.821442 28.2793 0.821442ZM16.9475 17.7414C16.9475 23.9654 22.0209 29.011 28.2793 29.011C31.2847 29.011 34.1669 27.8237 36.2921 25.7102C38.4172 23.5968 39.6111 20.7303 39.6111 17.7414C39.6111 11.5173 34.5377 6.47175 28.2793 6.47175C22.0209 6.47175 16.9475 11.5173 16.9475 17.7414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarWhitebg);
export default __webpack_public_path__ + "static/media/avatar-whitebg.1242f0c9a48ae7c642c8ec4c4b2ab7ad.svg";
export { ForwardRef as ReactComponent };